import React from 'react';

const DoubleClickTooltip = () => {
  return (
    <div className="double-click-tooltip">
      <div className="double-click-tooltip__icon"></div>
      <div className="double-click-tooltip__content">
        <div className="double-click-tooltip__text">{i18n.t('tooltip_text')}</div>
      </div>
    </div>
  );
};

export default DoubleClickTooltip;
